import { render, staticRenderFns } from "./OutcallDetail.vue?vue&type=template&id=1a581bf6&scoped=true&"
import script from "./OutcallDetail.vue?vue&type=script&lang=js&"
export * from "./OutcallDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutcallDetail.vue?vue&type=style&index=0&id=1a581bf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a581bf6",
  null
  
)

export default component.exports